"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex justify-content-center align-items-center'
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-spinner fa-spin fa-fw"
  }));
};

var _default = Loading;
exports.default = _default;